import { Chip } from '@mui/material';
import React from 'react';

const WorkflowStateBadge = ({ contractState }) => {
    const stateProperties = {
        PDF_UPLOADED: {
            text: 'PDF hochgeladen',
            backgroundColor: '#f5f5f5',
            color: '#616161',
            borderColor: '#bdbdbd'
        },
        OCR_DONE: {
            text: 'LLM Bewertung läuft',
            backgroundColor: '#e3f2fd',
            color: '#0277bd',
            borderColor: '#90caf9'
        },
        LLM_CLASSIFICATION_DONE: {
            text: 'LLM Bewertung verschickt.',
            backgroundColor: '#fff3e0',
            color: '#ef6c00',
            borderColor: '#ffcc80'
        },
        FINISHED_REVIEW: {
            text: 'Anw. Bewertung verschickt.',
            backgroundColor: '#f3e5f5',
            color: '#7b1fa2',
            borderColor: '#ce93d8'
        },
        LLM_RECTIFICATION_DONE: {
            text: 'Anw. Bewertung verschickt. (LLM Korr.)',
            backgroundColor: '#f3e5f5',
            color: '#7b1fa2',
            borderColor: '#ce93d8'
        },
        FINISHED: {
            text: 'Anw. Korrektur verschickt.',
            backgroundColor: '#e8f5e9',
            color: '#2e7d32',
            borderColor: '#a5d6a7'
        },
        HEALTHY: {
            text: 'Vertrag Okay',
            backgroundColor: '#e8f5e9',
            color: '#2e7d32',
            borderColor: '#a5d6a7'
        }
    };

    const activeState = stateProperties[contractState] || {
        text: contractState,
        backgroundColor: '#f5f5f5',
        color: '#616161',
        borderColor: '#bdbdbd'
    };

    return (
        <Chip
            label={activeState.text}
            sx={{
                backgroundColor: activeState.backgroundColor,
                color: activeState.color,
                border: `1px solid ${activeState.borderColor}`,
                borderRadius: '8px',
                fontWeight: 500
            }}
        />
    );
};

export default WorkflowStateBadge;
